import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { setInitialSteps } from "../../../../redux/shared/actions";
import { addLesson, getVideo } from "../../../../redux/educator/actions";
import { StateType } from "../../../../utils/types";
import {
  selectVideos,
  selectAlertsLoading,
  selectLessonSubmitLoading,
} from "../../../../redux/educator/selector";

const mapStateToProps = (state: StateType) => ({
  videos: selectVideos(state),
  videosLoading: selectAlertsLoading(state),
  submitLoading: selectLessonSubmitLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getVideo,
      setInitialSteps,
      addLesson,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
